import React from "react";
import Services from ".";
import { Selectors } from "@/store/masterProfile/selectors";
import { connect } from "react-redux";
import { Actions as ModalActions } from "@/store/modals/slice";
import { Selectors as BasketSelectors } from "@/store/basket/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Effects as BasketEffects } from "@/store/basket/effects";
import { Effects as PortfolioEffects } from "@/store/portfolio/effects";
import { Actions } from "@/store/masterProfile/slice";
import { Actions as PortfolioActions } from "@/store/portfolio/slice";
import { MasterDiscountsService } from "@/services/masterDiscounts";

const connector = connect(
  (state, props) => ({
    services: Selectors.getRenderReadyServices(state, props.specs),
    isOwner: Selectors.isOwner(state),
    basket: BasketSelectors.getBasket(state),
    masterId: Selectors.getMasterId(state),
    clients: Selectors.getClientsForBonusForm(state),
    servicesFilter: Selectors.getServicesFilter(state),
    authUserId: UserSelectors.getUserId(state),
  }),
  {
    openAuthModal: ModalActions.openAuth,
    addToBasket: BasketEffects.addToBasket,
    removeFromBasket: BasketEffects.removeFromBasket,
    addPortfolio: PortfolioEffects.addPortfolio,
    updateServicesFilter: Actions.updateServicesFilter,
    openGallery: PortfolioActions.openGallery,
  }
);
const ServicesContainer = (props) => {
  return (
    <Services
      {...props}
      createDiscount={MasterDiscountsService.createDiscount}
      updateDiscount={MasterDiscountsService.updateDiscount}
      deleteDiscount={MasterDiscountsService.removeDiscount}
    />
  );
};

export default connector(ServicesContainer);
